/**
 * Utility functions for sorting data by date fields
 */

interface DateSortable {
  created_at?: string;
  updated_at?: string;
}

/**
 * Gets the latest date from created_at or updated_at fields
 * @param item - Object with created_at and/or updated_at fields
 * @returns The latest timestamp in milliseconds
 */
export const getLatestDate = (item: DateSortable): number => {
  const createdAt = item.created_at ? new Date(item.created_at).getTime() : 0;
  const updatedAt = item.updated_at ? new Date(item.updated_at).getTime() : 0;
  return Math.max(createdAt, updatedAt);
};

/**
 * Sorts an array of items by their latest date (created_at or updated_at) in descending order
 * @param items - Array of items to sort
 * @returns Sorted array with most recent items first
 */
export const sortByLatestDate = <T extends DateSortable>(items: T[]): T[] => {
  return items.sort((a, b) => getLatestDate(b) - getLatestDate(a));
};
